import { Box, SystemIcon, Typography } from '@wishket/design-system';

interface CollectionStatusMenuProps {
  isPublic: boolean;
  onStatusChange: (status: boolean) => void;
}

const CollectionStatusMenu = ({
  isPublic,
  onStatusChange,
}: CollectionStatusMenuProps) => {
  const getSelectedStyle = (isSelected: boolean) => {
    return isSelected ? 'font-medium text-primary-500' : 'text-w-gray-700';
  };

  return (
    <Box className="flex h-[116px] w-[120px] flex-col rounded-xl bg-white p-2 shadow-graymedium">
      <Box
        className="flex cursor-pointer items-center gap-2 rounded-xl px-4 py-3 hover:bg-primary-10"
        onClick={() => onStatusChange(true)}
      >
        <SystemIcon
          name="medium_public"
          className={getSelectedStyle(isPublic)}
        />
        <Typography variant="body1" className={getSelectedStyle(isPublic)}>
          공개
        </Typography>
      </Box>
      <Box
        onClick={() => onStatusChange(false)}
        className="flex cursor-pointer items-center gap-2 rounded-xl px-4 py-3 hover:bg-primary-10"
      >
        <SystemIcon
          name="medium_private"
          className={getSelectedStyle(!isPublic)}
        />
        <Typography variant="body1" className={getSelectedStyle(!isPublic)}>
          비공개
        </Typography>
      </Box>
    </Box>
  );
};
export default CollectionStatusMenu;
